import React, { useMemo } from 'react'
import { useLocation } from 'react-router-dom'
import apiService from 'services/api'
import { SlideOutNavGroup, NavGroupItem } from './SlideOutNavGroup'
import styled from 'styled-components/macro'

const LoadingText = styled.div`
  padding: 16px;
  font-size: 14px;
  color: #6e6e6e;
`

const NavList = styled.ul`
  list-style: none;
  margin: 0;
  padding: 0;
  display: flex;
  flex-direction: column;
  gap: 6px;
`

export const TargetsSlideOutContent: React.FC = () => {
  const api = apiService()
  const location = useLocation()
  const { data: companyCatAndSub, isLoading } =
    api.useGetActiveCompanyCategoriesAndTypes()

  // Transform API data into nav groups
  const categoryGroups = useMemo(() => {
    if (!companyCatAndSub) return []

    return companyCatAndSub.map((category) => {
      const items: NavGroupItem[] = category.sub_categories.map((sub) => ({
        label: sub.name,
        path: `/opportunities/${category.slug}/${sub.slug}/`,
      }))

      // Check if this category is active based on current path
      const isActiveGroup = location.pathname.includes(
        `/opportunities/${category.slug}/`
      )

      return {
        label: category.name,
        items,
        isActiveGroup,
        // Default expand the active group
        defaultExpanded: isActiveGroup,
      }
    })
  }, [companyCatAndSub, location.pathname])

  if (isLoading) {
    return <LoadingText>Loading categories...</LoadingText>
  }

  if (!categoryGroups.length) {
    return <LoadingText>No categories available</LoadingText>
  }

  return (
    <NavList>
      {categoryGroups.map((group) => (
        <SlideOutNavGroup
          key={group.label}
          label={group.label}
          items={group.items}
          section="targets"
          defaultExpanded={group.defaultExpanded}
          isActiveGroup={group.isActiveGroup}
        />
      ))}
    </NavList>
  )
}
